import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const deTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Name (Kleinbuchstaben, keine Sonderzeichen)',
    add: 'Hinzufügen',
    allowedFileTypes: 'Zulässige Dateitypen',
    allowedFileTypesDescription:
      'Beschränken Sie zulässige Dateitypen (z. B. image/*, application/pdf). Lassen Sie das Feld leer, um alle Typen zuzulassen.',
    allowMultipleFiles: 'Mehrere Dateien zulassen',
    amountInCents: 'Betrag in Cent',
    basePrice: 'Grundpreis',
    bcc: 'BCC',
    brand: 'Marke',
    cc: 'CC',
    checkboxPlural: 'Kontrollkästchenfelder',
    checkboxSingular: 'Kontrollkästchen',
    checkedByDefault: 'Standardmäßig aktiviert',
    chooseConfirmationType:
      'Wählen Sie aus, ob nach dem Absenden des Formulars eine Nachricht auf der Seite angezeigt oder auf eine andere Seite weitergeleitet werden soll.',
    condition: 'Zustand',
    confirmationMessage: 'Bestätigungsnachricht',
    confirmationType: 'Bestätigungstyp',
    countryPlural: 'Länderfelder',
    countrySingular: 'Land',
    creditCard: 'Kreditkarte',
    customURL: 'Benutzerdefinierte URL',
    datePlural: 'Datumsfelder',
    dateSingular: 'Datum',
    defaultValue: 'Standardwert',
    divide: 'Teilen',
    documentToLinkTo: 'Dokument, auf das verlinkt werden soll',
    doesNotEqual: 'Ist nicht gleich',
    emailFrom: 'E-Mail von',
    emailPlural: 'E-Mail-Felder',
    emailsDescription:
      'Senden Sie benutzerdefinierte E-Mails, wenn das Formular gesendet wird. Verwenden Sie durch Kommas getrennte Listen, um dieselbe E-Mail an mehrere Empfänger zu senden. Um auf einen Wert aus diesem Formular zu verweisen, schließen Sie den Namen dieses Felds in doppelte geschweifte Klammern ein, z. B. {{firstName}}. Sie können einen Platzhalter {{*}} verwenden, um alle Daten auszugeben, und {{*:table}}, um sie als HTML-Tabelle in der E-Mail zu formatieren.',
    emailSingular: 'E-Mail',
    emailTo: 'E-Mail an',
    equals: 'Gleich',
    field: 'Feld',
    fields: 'Felder',
    fieldWidth: 'Feldbreite (Prozent)',
    hasAnyValue: 'Hat irgendeinen Wert',
    internalLink: 'Interner Link',
    label: 'Etikett',
    maxFileSize: 'Maximale Dateigröße (Byte)',
    maxFileSizeDescription: 'Maximale Dateigröße in Bytes. Für keine Begrenzung leer lassen.',
    message: 'Nachricht',
    messageDescription: 'Geben Sie die Nachricht ein, die in dieser E-Mail gesendet werden soll.',
    messagePlural: 'Nachrichtenblöcke',
    messageSingular: 'Nachricht',
    mimeType: 'MIME-Typ',
    mimeTypePlural: 'MIME-Typen',
    mimeTypeSingular: 'MIME-Typ',
    multiply: 'Multiplizieren',
    numberPlural: 'Zahlenfelder',
    numberSingular: 'Nummer',
    optionPlural: 'Optionen',
    optionSingular: 'Option',
    paymentFieldPlural: 'Zahlungsfelder',
    paymentFieldSingular: 'Zahlung',
    paymentProcessor: 'Zahlungsabwickler',
    paymentStatus: 'Status',
    placeholder: 'Platzhalter',
    priceConditions: 'Preisbedingungen',
    priceConditionsPlural: 'Preisbedingungen',
    priceConditionsSingular: 'Preisbedingung',
    radioOptions: 'Optionen für Radioattribute',
    radioPlural: 'Funkfelder',
    radioSingular: 'Radio',
    redirect: 'Weiterleiten',
    replyTo: 'Antwort an',
    required: 'Erforderlich',
    selectOptions: 'Wählen Sie Optionen',
    selectPlural: 'Wählen Sie Felder aus',
    selectSingular: 'Auswählen',
    statePlural: 'Staatsfelder',
    stateSingular: 'Staat',
    staticValue: 'Statischer Wert',
    subject: 'Betreff',
    submitButton: 'Beschriftung der Schaltfläche „Senden“',
    subtract: 'Subtrahieren',
    textareaPlural: 'Textfeldfelder',
    textareaSingular: 'Textbereich',
    textPlural: 'Textfelder',
    textSingular: 'Text',
    title: 'Titel',
    token: 'Token',
    uploadCollection: 'Sammlung hochladen',
    uploadCollectionDescription:
      'Wählen Sie aus, in welcher Upload-Sammlung Dateien gespeichert werden sollen',
    uploadFieldPlural: 'Felder hochladen',
    uploadFieldSingular: 'Hochladen',
    urlToRedirectTo: 'URL zur Weiterleitung',
    value: 'Wert',
    valueOfField: 'Wert des Feldes',
    valueType: 'Werttyp',
  },
}

export const de: PluginLanguage = {
  dateFNSKey: 'de',
  translations: deTranslations,
}
